/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import {IvyCarouselModule} from 'angular-responsive-carousel';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpRequest } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgxSelectModule } from 'ngx-select-ex';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  NbAuthJWTInterceptor,
  NbAuthModule,
  NbAuthService,
  NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
  NbTokenLocalStorage,
} from '@nebular/auth';
import { AuthInterceptor } from './auth.interceptor';
import { SharedRefreshAuthService } from './shared-refresh-auth.service';
import { MissingReferenceInterceptor } from '../@core/utils/missing-reference.interceptor';
import { AuthGuard } from './auth.guard';
import { AdminGuard } from './admin.guard';
import { AuthPipe } from './auth.pipe';
import { RoleProvider } from './role.provider';
import { NbRoleProvider, NbSecurityModule } from '@nebular/security';
import { AuthNotRequiredDirectiveModule } from './auth-not-required.directive'; 


import {
  NgxLoginComponent,
  NgxAuthComponent,
  NgxAuthBlockComponent,
  NgxLogoutComponent,
  NgxRegisterComponent,
  NgxRequestPasswordComponent,
  NgxResetPasswordComponent,
  RegisterTenantComponent,
  OtpVerifyDialogComponent,
  TenantListComponent,
  ContactAdministartorComponent,
  PatientSignupComponent,
  PatientLoginComponent, 
  ResetPasswordInsideAppComponent
} from './components';

import {
  NbAlertModule,
  NbCardModule,
  NbIconModule,
  NbLayoutModule,
  NbCheckboxModule,
  NbInputModule,
  NbButtonModule,
  NbStepperModule,
  NbTabsetModule

} from '@nebular/theme';
import { AuthRoutingModule } from './auth-routing.module';
import { WellSpringSiteModule } from './components/well-spring-site/well-spring-site.module';
import { ComponentsModule } from '../@components/components.module';
import { authOptions } from './auth.settings';
import { authSettings } from './access.settings';
import { MobileGuard } from './mobile.guard';
import { CaroselComponent } from './components/carosel/carosel.component';
import { PatientVideocallLoginComponent } from './components/patient-videocall-login/patient-videocall-login.component';
import { PatientVideocallComponent } from './components/patient-videocall/patient-videocall.component';
import { CallService } from '../@core/backend/common/services/videoCall.service';
import { DoctorSignupComponent } from './components/doctor/doctor-signup/doctor-signup.component';
import { DoctorQualificationComponent } from './components/doctor/doctor-qualification/doctor-qualification.component';
import {OwlDateTimeModule, OwlNativeDateTimeModule} from 'ng-pick-datetime';
import { NotRequiredDirectiveModule } from '../pages/Masters/not-required.directive';
import { MarkAsteriskDirectiveModule } from '../pages/Masters/required-astreik.directive';
import { PatientportalloginComponent } from './components/patientportallogin/patientportallogin.component';
import { PatientportalheadersComponent } from './components/patientportalheaders/patientportalheaders.component';
import { PatientportalfooterComponent } from './components/patientportalfooter/patientportalfooter.component';
import { CareLoginComponent } from './components/care-login/care-login.component';
import { PortalAppointmentBookingComponent } from './components/portal-appointment-booking-component/portal-appointment-booking-component.component';
import { BookingSummaryLoginComponent } from './components/booking-summary-login/booking-summary-login.component';
import { OtpverificationComponent } from './components/otpverification/otpverification.component';
import { QueuemanagementComponent } from './components/queuemanagement/queuemanagement.component';
import { PatientportaldocdetailsComponent } from './components/patientportaldocdetails/patientportaldocdetails.component';
import { AssesmentComponent } from './components/assesment/assesment.component';

const GUARDS = [AuthGuard, AdminGuard, MobileGuard];
const PIPES = [AuthPipe];
const COMPONENTS = [
  NgxLoginComponent,
  NgxAuthComponent,
  NgxLogoutComponent,
  NgxRegisterComponent,
  NgxRequestPasswordComponent,
  NgxResetPasswordComponent,
  NgxAuthBlockComponent,
  RegisterTenantComponent,
  OtpVerifyDialogComponent,
  TenantListComponent,
  ContactAdministartorComponent,
  PatientLoginComponent,
  PatientSignupComponent,
  ResetPasswordInsideAppComponent
];

const NB_MODULES = [
  NbIconModule,
  NbLayoutModule,
  NbCardModule,
  NbAlertModule,
  NbCheckboxModule,
  NbInputModule,
  NbButtonModule,
  NbStepperModule,
  OwlDateTimeModule, 
  OwlNativeDateTimeModule,
  NbTabsetModule
];

export function filterInterceptorRequest(req: HttpRequest<any>): boolean {
  return ['/auth/login', '/auth/sign-up', '/auth/request-pass', '/auth/refresh-token']
    .some(url => req.url.includes(url));
}

@NgModule({
  declarations: [...PIPES, ...COMPONENTS, OtpVerifyDialogComponent,CaroselComponent, PatientVideocallLoginComponent, PatientVideocallComponent, DoctorSignupComponent, DoctorQualificationComponent,PatientportalloginComponent, PortalAppointmentBookingComponent, BookingSummaryLoginComponent,PatientportalheadersComponent, PatientportalfooterComponent,  OtpverificationComponent, AssesmentComponent,QueuemanagementComponent, PatientportaldocdetailsComponent, CareLoginComponent],
  imports: [
    WellSpringSiteModule,
    IvyCarouselModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ComponentsModule,
    NgxSelectModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
  MarkAsteriskDirectiveModule ,
  NotRequiredDirectiveModule,
    AuthNotRequiredDirectiveModule,
    ...NB_MODULES,
    NbAuthModule.forRoot(authOptions),
  ],
  exports: [...PIPES, OtpVerifyDialogComponent, NgxRegisterComponent, TenantListComponent,
    ContactAdministartorComponent, PatientSignupComponent,PatientportalheadersComponent, PatientportalfooterComponent],
  providers: [
    NbSecurityModule.forRoot({
      accessControl: authSettings,
    }).providers,
    {
      provide: NbRoleProvider, useClass: RoleProvider,
    },
    {
      provide: NbTokenLocalStorage, useClass: NbTokenLocalStorage,
    },
    // Declared after NbAuthModule.forRoot() so it replaces Nebular's own NbAuthService for every module.
    { provide: NbAuthService, useClass: SharedRefreshAuthService },
  ],
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        { provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: filterInterceptorRequest },
        { provide: HTTP_INTERCEPTORS, useClass: NbAuthJWTInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        // After AuthInterceptor, so the resent request already carries the bearer token.
        { provide: HTTP_INTERCEPTORS, useClass: MissingReferenceInterceptor, multi: true },
       ...GUARDS
   ],
    };
  }
}
